import React from 'react';
import { PropertyCardBadges } from './PropertyCardBadges';

interface PropertyCardStatusProps {
    status: string;
    isDeleted: boolean;
    isUpdated: boolean;
    isInactive: boolean;
    targetStatus: string | null;
    isNewlyAdded?: boolean;
    es_preventa?: boolean;
    hasCommissionOverride?: boolean;
    tiene_oferta?: boolean;
    valor_oferta?: number | null;
    hasDaviviendaCreditPromo?: boolean;
    isClientRole?: boolean;
    tags?: string[] | null;
    tag?: string[] | null;
}

export const PropertyCardStatus: React.FC<PropertyCardStatusProps> = ({ 
    isDeleted, isUpdated, isInactive, targetStatus, isNewlyAdded, es_preventa, hasCommissionOverride,
    tiene_oferta, valor_oferta, hasDaviviendaCreditPromo, isClientRole, tags, tag
}) => {
    const hasTags = Boolean((tags && tags.length > 0) || (tag && tag.length > 0));
    if (!isDeleted && !isInactive && !isUpdated && !isNewlyAdded && !es_preventa && !hasCommissionOverride && !tiene_oferta && !hasDaviviendaCreditPromo && !hasTags) return null;

    const isCritical = isDeleted || isInactive || isUpdated;

    // Renderizado para estados críticos (Overlay centrado)
    if (isCritical) {
        const getLabel = () => {
            if (isDeleted) return 'ELIMINADO';
            if (isUpdated) return targetStatus === 'Vendido' ? 'ACTUALIZADO Y VENDIDO' : 'ACTUALIZADO';
            if (isInactive) return 'INACTIVO';
            return '';
        };

        const getBgColor = () => {
            if (isDeleted) return 'bg-red-600';
            if (isUpdated) return targetStatus === 'Vendido' ? 'bg-gray-800' : 'bg-blue-600';
            if (isInactive) return 'bg-orange-500';
            return 'bg-gray-500';
        };

        return (
            <div className="absolute inset-0 bg-gray-900/20 z-20 flex items-center justify-center pointer-events-none">
                <div className={`px-4 py-1.5 rounded font-black text-white text-[10px] shadow-xl tracking-tighter ${getBgColor()}`}>
                    {getLabel()}
                </div>
            </div>
        );
    }

    // Renderizado para badges informativos con soporte de carrusel/rotación
    return (
        <PropertyCardBadges 
            hasDaviviendaCreditPromo={hasDaviviendaCreditPromo}
            tiene_oferta={tiene_oferta}
            valor_oferta={valor_oferta}
            es_preventa={es_preventa}
            hasCommissionOverride={hasCommissionOverride}
            isNewlyAdded={isNewlyAdded}
            isClientRole={isClientRole}
            tags={tags}
            tag={tag}
        />
    );
};
